import tippy from "tippy.js";
import cash from "cash-dom";

if (cash("#roster").length) {
    const mq = window.matchMedia("(max-width: 1023px)");
    if (mq.matches && cash(".shift__card").length) {
        cash('.shift__card').each(function (i, element) {
            let content = `<div class="inline-flex">${cash(element).find('.shift__info_line').html()}</div>`;
            tippy(element, {
                allowHTML: true,
                content: content
            })
        })
    }

    if (cash(".shift__colleagues").length) {
        cash('.shift__colleagues').each(function (i, element) {
            let content = `<div class="inline-flex">${cash(element)[0].dataset.tooltip}</div>`;
            tippy(element, {
                allowHTML: true,
                content: content
            })
        })
    }
}